import { dateTimeToDate } from './dateTimeToDate';

/**
 * @param {Partial<WistiaDateTimeObject>} dateTime - a dateTime object
 * @returns {string | null} - string with the ISO-8601 string or null
 */
export const dateTimeToISO = (dateTime: Partial<WistiaDateTimeObject>): string | null =>
  dateTimeToDate(dateTime)?.toISOString() ?? null;
